import createInterceptor from './Interceptor';

const baseURL = import.meta.env.VITE_DASHBOARD_API_URL;

const axiosInstance = createInterceptor({
  baseURL,
  withCredentials: true,
  responseType: 'blob',
  exposedHeaders: 'Authorization',
}, true);

export default axiosInstance;
